import React, { Suspense, lazy } from "react";
import { formsPreviewAllowed } from "./gate";

// Tiny route shell: the preview itself (renderer, CSS, sample defs) is a
// separate lazy chunk, so the main bundle only gains this file.
const FormsPreview = lazy(() => import("./FormsPreview"));

export default function FormsPreviewRoute() {
  if (!formsPreviewAllowed()) return <>Page not available</>;
  return (
    <Suspense fallback={null}>
      <FormsPreview />
    </Suspense>
  );
}
